import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SharedModule } from '../../modules/shared.module';
import { TableColumn } from '../../interfaces/table-data/table-data.interface';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-data-table',
  imports: [SharedModule],
  templateUrl: './data-table.component.html',
  styleUrl: './data-table.component.scss'
})
export class DataTableComponent {

  @ViewChild('dt') table!: Table;

  @Input() data: any[] = [];
  @Input() columns: TableColumn[] = [];

  @Input() selection: any[] = [];
  @Output() selectionChange = new EventEmitter<any[]>();

  @Input() rows = 10;
  @Input() rowsPerPageOptions = [10, 20, 50];
  @Input() globalFilterFields: string[] = [];

  /** ✅ Public API */
  filterGlobal(value: string, matchMode: string = 'contains'): void {
    this.table?.filterGlobal(value, matchMode);
  }

  clearGlobalFilter(): void {
    this.table?.clear();
  }
}
